// extracted by mini-css-extract-plugin
export var form = "_bx-0";